import AsynAutoComplete from '../AsynAutoComplete/AsynAutoComplete';
import { memo, useCallback, useMemo } from 'react';
import useAuth from '../../../hooks/useAuth';
import { useLocation } from 'react-router-dom';
import { PageName } from '../../../utils/screenPermission';
import commonApi from '../../../services/api/CommonApi';

const ScenarioAutocomplate = ({
  label = 'Scenario',
  multiple = false,
  selectedItem,
  onValueChange,
  name,
  error,
  helperText,
  parameter,
  renderOptionDecorator = false,
  required,
  extraFilter = null
}) => {
  const location = useLocation();
  const pages = useMemo(() => location.pathname.split('/').filter(Boolean)[0], [location]);
  const { assignedSourceSystems, assignedDivisions } = useAuth();
  const fetchDataHandler = useCallback(
    async (data) => {
      const { Data } = await commonApi.getScenariosAutoComplete({
        ...data,
        scenario: data.text,
        sourceSystemIds: data.sourceSystemIds?.length ? data.sourceSystemIds : assignedSourceSystems,
        functionality: PageName[pages],
        clientIds: extraFilter?.clientIDs && extraFilter?.clientIDs.length ? extraFilter.clientIDs : [],
        divisionIds: data.divisionIds?.length ? data.divisionIds : assignedDivisions,
        ...extraFilter
      });
      if (Data) {
        return Data.map((x) => ({ id: x.MDID, text: x.MDName, masterDataItems: x.MasterDataItems, ClientID: x.ClientID, SourceSystemRecordID: x.SourceSystemRecordID, Active: x.Active, ClientName: x.ClientName, ClientShortName: x.ShortName }));
      }
      return [];
    },
    [assignedDivisions, assignedSourceSystems, extraFilter, pages]
  );

  const getOptionLabel = useCallback((option) => {
    if (typeof option === 'string') {
      return option;
    }

    if (typeof option === 'number') {
      return option;
    }

    return option.text;
  }, []);

  const isOptionEqualToValue = useCallback((option, value) => {
    if (!value) {
      return false;
    }

    if (typeof value === 'string') {
      return option.text.toLocaleLowerCase().trim() === value.toLocaleLowerCase().trim();
    }

    if (typeof value === 'number') {
      return option.id === value;
    }

    return option.id === value.id;
  }, []);

  return (
    <AsynAutoComplete
      multiple={multiple}
      label={label}
      required={required}
      isSearchOnType
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      selectedItem={selectedItem}
      onValueChange={onValueChange}
      onFetchData={fetchDataHandler}
      parameter={parameter}
      error={error}
      helperText={helperText}
      name={name}
      renderOptionDecorator={renderOptionDecorator}
      isVisibleSourceSystem={false}
      isHover
    />
  );
};

export default memo(ScenarioAutocomplate);
